import OliverText from "@builder/components/general/OliverText";
import { BaseLayer, BaseLayerTypes } from "@common/build/types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import OliverImage from "../../OliverImage";
import SingleLayer from "./SingleLayer";
import "./style.scss";
import { useAppDispatch } from "@builder/store/store";
import { addLayer } from "@builder/store/slices/BuilderSlice/builderSlice";
import TooltipElement from "@builder/components/general/Tooltip";

interface LayerCollapseProps {
    title: string;
    children: BaseLayer[];
    open?: boolean;
    type: BaseLayerTypes;
    tooltip?: string;
}
const LayerCollapse: React.FC<LayerCollapseProps> = ({ title, children, type, tooltip }: LayerCollapseProps) => {
    const { t } = useTranslation();
    const [isCollapsed, setIsCollapsed] = useState<boolean>(!children.length);

    const dispatch = useAppDispatch();
    const handleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    const handleAddLayer = () => {
        dispatch(
            addLayer({
                name: `${t("sidebarCollapse.New")} ${t("sidebarCollapse." + (type === "pages" ? "Page" : type === "popups" ? "Pop-up" : "cfd"))}`,
                type
            })
        );
        if (isCollapsed) {
            setIsCollapsed(false);
        }
    };

    return (
        <div className="layer-collapse-wrapper">
            <div className="title-row">
                <div className="flex" onClick={handleCollapse}>
                    {
                        <OliverImage
                            src="/angled-arrow-down-dark.svg"
                            style={{
                                transition: "transform 0.1s linear",
                                transform: isCollapsed ? "rotate(-90deg)" : "rotate(0deg)",
                                width: "24px",
                                height: "24px"
                            }}
                        />
                    }

                    <OliverText text={t("sidebarCollapse." + title)} size="s" weight="light" />
                </div>

                {tooltip && (
                    <TooltipElement text={tooltip} position="bottom" extraStyle={{ width: "200px" }}>
                        <div className="add" onClick={handleAddLayer}>
                            <img src="/plus.svg" />
                        </div>
                    </TooltipElement>
                )}

                {!tooltip && (
                    <div className="add" onClick={handleAddLayer}>
                        <img src="/plus.svg" />
                    </div>
                )}
            </div>
            {!isCollapsed && (
                <div className="layer-collapse-content">
                    {children.length ? (
                        children.map((baseLayer, idx) => <SingleLayer key={baseLayer.id} baseLayer={baseLayer} type={type} index={idx} />)
                    ) : (
                        <span className="no-layers">
                            <OliverText text={`No ${type} to show`} size="xs" color="base-grey" translatePrefix="sidebarCollapse." />
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};

export default LayerCollapse;
